"use client";

import { sendGTMEvent } from "@next/third-parties/google";

const EVENTS = Object.freeze({
  BOOK_DEMO_SUBMITTED: "book_demo_submitted",
});

function trackEvent(event, params = {}) {
  sendGTMEvent({
    event,
    ...params,
  });
}

export { EVENTS, trackEvent };
